// extracted by mini-css-extract-plugin
export var divider = "_cy-7";
export var itemsToggle = "_cy-8";
export var mergeModal = "_cy-1";
export var optionCard = "_cy-4";
export var radioGroup = "_cy-6";
export var radioOption = "_cy-0";
export var selected = "_cy-5";
export var shipmentOptions = "_cy-2";
export var tableOptions = "_cy-3";